import { cn } from '@/utils/helper';

interface HeadColumn {
  label: string | React.ReactNode;
  value: string;
  className?: string;
}

interface DataRow {
  [key: string]: React.ReactNode;
}

interface RewardCardProps {
  data: DataRow[];
  heads: HeadColumn[];
}

const RewardCard = ({ data, heads }: RewardCardProps) => {
  return (
    <div className='w-full'>
      <div className='flex bg-primary justify-between py-5 px-8'>
        {heads.map(({ label, value, className }) => {
          return (
            <div className={cn('text-white text-base font-medium', className)} key={value}>
              {label}
            </div>
          );
        })}
      </div>
      <div className='border-x'>
        {data.map((obj, index) => {
          return (
            <div key={index} className='flex flex-col lg:flex-row lg:justify-between lg:divide-x border-b px-[22px] lg:px-8 max-lg:py-[14px] bg-white dark:bg-jet-black '>
              {heads.map(({ value: columnKey, className }) => {
                return (
                  <div key={columnKey} className={cn('lg:py-5 w-max pr-2', className)}>
                    {obj[columnKey]}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RewardCard;
